<template>
  <div>
    <div class="myInquiry_list">
      <div class="Head_box">
        <div style="display:flex;align-items:center;">
          <div class="avatar">
            <img :src="item.imageUrl" height="100%" style="border-radius:50%;" width="100%">
          </div>
          <div style="margin-left:10px;">
            <div class="nickName">{{ item.createName }}</div>
            <div class="time">
              {{ myLineInquiry == 4 ? '客户' : '您' }}于{{ dateFormatYMD(item.createTime, '.') }}日{{ dateFormatHM(item.createTime) }}分提出一个
              <span v-if="item.resourceType!=0&&(!item.resourceType)">询价需求</span>
              <span v-else><span class="Icon">{{ resouceTypeObj[item.resourceType] }}</span>&nbsp;询价</span>
              &nbsp;&nbsp;<span
              v-if="item.planId&&item.planId!=''">行程：{{ item.planId }}</span>
              <span v-if="item.condition===0" class="cancelbtn">取消</span>
              <span v-if="item.condition===1" class="cancelbtn1">已取消</span>
              <a style="color: blue;" v-if="rightShow" @click="getInquiryLog(item)">操作记录</a>
            </div>
          </div>
        </div>
        <div style="position:relative;" v-if="rightShow">
            <div class="bubble_box">
                <div v-if="item.newNumber!=0||item.readNumber!=0">
                    <div>NEW<span class="numberBox">{{ item.newNumber }}</span></div>
                    <div>已阅<span class="numberBox">{{ item.readNumber }}</span></div>
                </div>
                <div v-if="myLineInquiry==4&&!item.fromInquiryId" class="box1">待转询</div>
                <div v-else-if="item.newNumber===0&&item.readNumber===0" class="box1">方案制作中
                </div>
                <i class="el-icon-caret-bottom"
                    style="font-size:0.2rem;color:#E64A19;margin-top: -7px;"></i>
            </div>
            <div class="inquiryId">询单号：{{ item.inquiryId }}</div>
        </div>
      </div>
      <div class="body">
        <div class="left">
          <div v-if="myLineInquiry==2||myLineInquiry==4">
            <div class="left_item">
              <div class="titleTwo">人数：</div>
              <div class="contentTwo">{{ item.peopleNumber }}</div>
            </div>
            <div v-if="item.planInfo&&item.planInfo.length>0" class="left_item">
              <div class="titleTwo">行程：</div>
              <div class="contentTwo">
                <span v-for="(item1,index) in item.planInfo" :key="index">{{ item1 }}&nbsp;&nbsp;</span>
              </div>
            </div>
            <div class="left_item">
              <div class="titleTwo">需求：</div>
              <div class="contentTwo">
                <span v-for="(item1,index) in item.needDetail" :key="index" style="line-height: 0.2rem;">
                  <br v-if="item1=='<br>'"/>
                  <span v-else
                        :style="(item1=='和'||item1=='或')?'font-weight: bold;color: #DB4E1A;':''">{{ item1 }}&nbsp;&nbsp;</span>
                </span>
              </div>
            </div>
            <div v-if="item.hotelRoomList&&item.hotelRoomList.length>0" class="productList">
                <div v-for="(product,ind) in item.hotelRoomList" :key="ind" class="list_item">
                    <i class="el-icon-video-play"></i>
                    {{ product.hotelRoomName }}&nbsp;&nbsp;{{ product.roomNumber }}间&nbsp;&nbsp;
                    <span
                        v-if="product.price!=''">锁死预算：{{ product.roomBudget }}{{ product.currency }}/间/晚</span>
                </div>
            </div>
            </div>
            <information-inquiry-info v-else :item="item"></information-inquiry-info>
        </div>
        <div class="right" v-if="rightShow">
          <div v-if="myLineInquiry==2||myLineInquiry==4" class="up">
            <p v-if="(myLineInquiry==2||(myLineInquiry==4&&item.fromInquiryId))&&item.newNumber===0&&item.readNumber===0">
                请您再耐心等待一下哦</p>
            <div v-else-if="myLineInquiry==4&&!item.fromInquiryId" class="down_button">
                <el-button type="primary" @click="zhaunxun(item)">转询</el-button>
            </div>
            <div v-else class="down_button">
                <i class="el-icon-arrow-down" style="font-size:0.25rem;color:#E64A19;font-weight:bold;line-height:0.25rem;
cursor:pointer;" @click="showProgramListTwo(item)"></i>
            </div>
          </div>
          <div v-if="myLineInquiry==1">
            <div v-for="(item1,index1) in item.sendCustomizerList" :key="index1">
                <img :src="item1.imageUrl"
                      style="width: 0.3rem;height: 0.3rem;border-radius: 50%;"/>
                <i class="el-icon-arrow-down" style="font-size:0.25rem;color:#E64A19;font-weight:bold;line-height:0.25rem;
cursor:pointer;" @click="showPlanListTwo(item,item1)"></i>
            </div>
            <div v-if="item.sendCustomizerList&&item.customizerNumber>item.sendCustomizerList.length"
                  class="up">
                将有{{ item.customizerNumber - item.sendCustomizerList.length }}位定制师为您发送方案,请您再耐心等待一下哦
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: {}
    },
    myLineInquiry:{
      type: Number,
      default: 2
    },
    rightShow:{
      type: Boolean,
      default: true
    }
  },
  data(){
    return{
      resouceTypeObj: {
        0: "酒店",
        1: "会议",
        2: "景点",
        3: "用车",
        4: "用餐",
        5: "导游",
        6: "签证",
        7: "商务",
        8: "特色体验",
        9: "服务",
        10: "交通",
      },
    }
  },
  methods:{
    showProgramListTwo(item){
      this.$emit("showProgramListTwo",item)
    },
    zhaunxun(item){
      this.$emit("zhaunxun",item)
    },
    getInquiryLog(item){
      this.$emit("getInquiryLog",item)
    }
  }
}
</script>
<style lang="css">
.myInquiry_list {
  border-radius: 15px 15px 0px 0px;
  background: white;
  box-shadow: 5px 5px 10px 3px rgba(0, 0, 0, 0.4);
  margin-top: 0.09rem;
  padding: 0.1rem;
  border-bottom: 3px solid #DB4E1A;
  font-size: 0.12rem;
  .Head_box {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .avatar {
      width: 0.35rem;
      height: 0.35rem;
    }
    .nickName {
      color: #E64A19;
    }
    .time {
      margin-top: 0.05rem;
      .Icon {
        display: inline-block;
        padding: 0.03rem 0.08rem;
        background: #EB764C;
        color: white;
        border-radius: 4px;
      }
    }
    .bubble_box {
      display: flex;
      position: absolute;
      top: -0.38rem;
      flex-direction: column;
      align-items: center;
      .numberBox {
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: white;
        margin-left: 0.02rem;
        color: #E64A19;
        text-align: center;
        line-height: 16px;
      }
      div {
        width: 1.2rem;
        height: 0.3rem;
        background: #E64A19;
        color: white;
        font-size: 0.12rem;
        font-weight: bold;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .box1 {
        background: #EDA88E;
      }
    }
    .inquiryId {
      color: rgb(230, 80, 25);
      width: 1.2rem;
      padding-left: 0.15rem;
    }
  }
  .body {
    background: #FAFAFA;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    padding: 10px;
    .left {
      border-right: 1px solid #ddd;
      width: 86%;
      .productList {
        .list_item {
          margin-top: 5px;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.8rem;
      .up {
        color: #ED8666;
        width: 0.7rem;
      }
    }
  }
}
.left_item {
  display: flex;
  margin: 10px 0px;
}
</style>
